export default {
  deliveryOnTrack: {
    id: 'track_parcel_delivery_on_track',
    defaultMessage: 'Delivery on track',
  },
  updatedDeliveryDate: {
    id: 'track_parcel_updated_delivery_date',
    defaultMessage: 'Updated delivery date',
  },
  deliveryDelayed: {
    id: 'track_parcel_delivery_delayed',
    defaultMessage: 'Delivery delayed',
  },
  delivered: {
    id: 'track_parcel_delivered',
    defaultMessage: 'Delivered',
  },
  estimatedDelivery: {
    id: 'track_parcel_estimated_delivery',
    defaultMessage: 'Estimated delivery',
  },
  deliveryBy: {
    id: 'track_parcel_delivery_by',
    defaultMessage: 'Delivery by',
  },
  trackingId: {
    id: 'track_parcel_tracking_id',
    defaultMessage: 'Tracking ID',
  },
  needHelp: {
    id: 'track_parcel_need_help',
    defaultMessage: 'Need help?',
  },
  forDeliveryQuestions: {
    id: 'track_parcel_for_delivery_questions',
    defaultMessage: 'For delivery questions, {contactCarrierLink, html}',
  },
  manageOrRescheduleDelivery: {
    id: 'track_parcel_manage_or_reschedule_delivery',
    defaultMessage:
      'To manage or reschedule your delivery, {contactCarrierLink, html}',
  },
  contactCarrier: {
    id: 'track_parcel_contact_carrier',
    defaultMessage: 'contact {carrierName}',
  },
  packageMissingOrDamaged: {
    id: 'track_parcel_package_missing_or_damaged',
    defaultMessage:
      'Package missing or arrived damaged? {contactBackMarketLink, html}',
  },
  reportMissingOrDamaged: {
    id: 'track_parcel_report_missing_or_damaged',
    defaultMessage:
      'To report a missing or damaged package, {contactBackMarketLink, html}',
  },
  contactBackMarket: {
    id: 'track_parcel_contact_back_market',
    defaultMessage: 'Contact Back Market',
  },
  delayedAlertTitle: {
    id: 'track_parcel_delayed_alert_title',
    defaultMessage: 'Check with {carrierName} for delivery updates',
  },
  delayedAlertDescription: {
    id: 'track_parcel_delayed_alert_description',
    defaultMessage:
      "The shipping provider hasn't shared news with us recently. Please check their website or contact their team for the most recent updates.",
  },
  delayedAlertButton: {
    id: 'track_parcel_delayed_alert_button',
    defaultMessage: 'Go to {carrierName} tracking page',
  },
}
